module.exports = __webpack_public_path__ + "media/site_templates/www.localgardeners.com.au/images/splash-c29d3ec74ec86f1ebba7fb0275383709.jpeg";